import { render } from "./InventoryCountFormProduct.vue?vue&type=template&id=670960a2"
import script from "./InventoryCountFormProduct.vue?vue&type=script&lang=js"
export * from "./InventoryCountFormProduct.vue?vue&type=script&lang=js"
script.render = render

export default script